import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "../../constants.js";
import { palette } from "../../theme/palette.js";
import { I as Icon } from "../../Icon.js";
import styles from "./styles.module.scss";
const SharingStatus = (props) => {
  const { color = "neutral", icon, children, className, testId, wrapText } = props;
  const sharingStatusClasses = classNames(styles["sharing-status"], className);
  const dotClasses = classNames(styles["sharing-status__dot"], styles[`sharing-status__dot--${color}`]);
  const labelClasses = classNames(styles["sharing-status__label"], styles[`sharing-status__label--${color}`], {
    [styles["sharing-status__label--wrap"]]: wrapText
  });
  return /* @__PURE__ */ jsxs("span", { className: sharingStatusClasses, "data-testid": testId, "data-analyticsid": AnalyticsId.SharingStatus, children: [
    /* @__PURE__ */ jsx("span", { className: dotClasses, children: /* @__PURE__ */ jsx(Icon, { color: palette.white, svgIcon: icon, size: IconSize.XXSmall }) }),
    /* @__PURE__ */ jsx("span", { className: labelClasses, children })
  ] });
};
export {
  SharingStatus as default
};
//# sourceMappingURL=index.js.map
